import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { config } from '@/config'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Build full storage URL for images
 * Handles both relative paths and full URLs
 */
export function getStorageUrl(path?: string | null): string {
  if (!path) return '/placeholder-team.png'
  
  // Already a full URL
  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('/')) {
    return path
  }
  
  // Relative path - prepend storage URL
  return `${config.storage.baseUrl}/${path}`
}

/**
 * Format boolean status to display text
 */
export function formatStatus(status: boolean): 'Active' | 'Inactive' {
  return status ? 'Active' : 'Inactive'
}

export function formatDate(date: string | Date, format: string = 'MMM DD, YYYY') {
  const d = new Date(date)
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  
  const day = d.getDate().toString().padStart(2, '0')
  const month = months[d.getMonth()]
  const year = d.getFullYear()
  
  return format
    .replace('DD', day)
    .replace('MMM', month ?? '')
    .replace('YYYY', year.toString())
}

export function truncate(str: string, length: number): string {
  if (str.length <= length) return str
  return str.slice(0, length) + '...'
}

export function slugify(str: string): string {
  return str
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

